<script setup lang="ts">
import LoaderSpinner from '@/components/Loaders/LoaderSpinner.vue'
import GwText from '@/components/lib/base/GwText/GwText.vue'
import TierTag from '@/components/Sub/TierTag.vue'
import OpenChatLink from '@/components/Payments/OpenChatLink.vue'
import type { PaymentPlan } from '@/types/paymentPlans'

interface Props {
  isLoading: boolean
  isUpdating: boolean
  isTimedOut: boolean
  selectedPlan: PaymentPlan | null
  formCreationError: boolean
}

const props = defineProps<Props>()
</script>

<template>
  <div
    v-if="!props.formCreationError && (props.isUpdating || props.isLoading) && !props.isTimedOut"
    data-tst="update_subscription_loader"
    class="d-flex f-column justify-center align-center h-100"
  >
    <LoaderSpinner
      class="flex align-center justify-center mb-5"
      style="--size: 8rem"
    />
    <GwText
      class="text-center text-wrap"
      variant="text_white_large_400"
    >
      {{ $t(`payment.${props.isLoading ? 'form_loading' : 'updating_subscription'}`) }}
    </GwText>
    <TierTag
      v-if="props.selectedPlan"
      class="f-center mt-2"
      data-tst="payment_upgrade_tier"
      :customGame="props.selectedPlan.type"
      :customTier="props.selectedPlan.tier"
      :paymentInterval="props.selectedPlan.interval"
    />
  </div>
  <div
    v-else-if="props.isUpdating && props.isTimedOut"
    class="d-flex f-row ga-0.5 justify-center align-center h-100"
  >
    <GwText
      variant="text_white_large_400"
      class="text-center text-wrap"
    >
      {{ $t('payment.update_subscription_timed_out') }}
      <OpenChatLink />
    </GwText>
  </div>
</template>
